import { useConfigurationData } from '@vfmfe/foundations';
import { useTranslation } from 'react-i18next';
import { validateEntitlements } from '../../modules/entitlements';
import { JourneyConfig, JourneySelectorProps } from '../../types';
import CardSelector from '../CardSelector';
import { JourneySelectorContainer } from './JourneySelector.styles';

export default function JourneySelector({ onSelectJourney }: JourneySelectorProps) {
    const journeys = useConfigurationData<JourneyConfig[]>('digital-journey-manifest-configuration', []);
    const { t } = useTranslation();

    if (!journeys || journeys.length === 0) {
        return null;
    }

    const visibleJourneys = journeys.filter(
        (journey) => !journey.entitlements || validateEntitlements([journey.entitlements])
    );

    if (visibleJourneys.length === 0) {
        return null;
    }

    const journeyButtons = visibleJourneys.map((journey) => ({
        id: journey.id,
        label: t(journey.title),
        icon: journey.icon
    }));

    const handleSelectJourney = (journeyId: string) => {
        const journey = visibleJourneys.find((journey) => journey.id === journeyId);
        if (journey) {
            onSelectJourney(journey);
        }
    };

    return (
        <JourneySelectorContainer>
            <CardSelector items={journeyButtons} onSelect={handleSelectJourney} title={t('menu_journey_title')} />
        </JourneySelectorContainer>
    );
}
